<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <p class="text-center green--text text-h4">Camera</p>
           <!-- <iframe ref="videoIframe" width="100%" height="450" frameborder="0" allowfullscreen
                  :src="videoSrc">
                </iframe>  -->
          <!-- <iframe src="htts://172.16.208.58:8080" frameborder="0"></iframe> -->

          <video id="my-video_html5_api" class="vjs-tech" preload="auto" poster="https://cspi.uz/storage/app/media/2023/security-cctv-camera-freepik2.jpg" data-setup="{}" style="width: 100%;" tabindex="-1" role="application" src="blob:https://art.cspi.uz/c810be4c-a898-48f6-ac05-241cc468e794">
            <source src="stream.m3u8" type="application/x-mpegURL" style="width: 100%;">
           <p class="vjs-no-js">
             To view this video please enable JavaScript, and consider upgrading to a
             web browser that
             <a href="https://videojs.com/html5-video-support/" target="_blank" class="vjs-hidden" hidden="hidden">supports HTML5 video</a>
           </p>
         </video>

          <!-- <video src="https://172.16.208.58:8080/jsfs.html"> </video> -->
        </v-col>

      </v-row>
    </v-container>

  </div>
</template>

<script>
export default {
  name:"Camera",
    data() {
    return {
      dialog: false,
      videoUrl: 'https://172.16.208.88:8080'
    }
  },

}
</script>

<style lang="scss" scoped></style>